import React, {useEffect, useState} from 'react';

// styling
import {Spacing, Colors} from '_styles';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setTotalFee, selectShoppingCartPrice } from '_redux/slices/marketplace/user-marketplace';

const CheckoutPricing = (props) => {

    const Row = ({label, value}) => (
        <div style={styles.row}>
            <span style={label == 'Total' ? styles.title : styles.label}>{label}:</span>
            <span style={label == 'Total' ? styles.title : styles.label}>{'€' + value}</span>
        </div>
    );

    // states
    const [subtotal, setSubtotal] = useState(0);
    const [fees, setFees] = useState(0);
    const [total, setTotal] = useState(0);

    // redux
    const dispatch = useDispatch();

    const shoppingCartPrice = useSelector(selectShoppingCartPrice)

    useEffect(() => {
        if(shoppingCartPrice){
            // calculate fees using price
            setSubtotal(shoppingCartPrice.toFixed(2));    // round to 2 decimal places

            let stripePercentage = 0.029;           // 2.9%
            let stripeFee = 0.25;                   // 25 cent fee
            
            // calculate fee
            let calculatedFees = (shoppingCartPrice * stripePercentage) + stripeFee; 
            setFees(calculatedFees.toFixed(2));     // round to 2 decimal places

            // calculate total
            let calculatedTotal = shoppingCartPrice + calculatedFees;
            setTotal(calculatedTotal.toFixed(2));   // round to 2 decimal places
        }
    }, [shoppingCartPrice])

    useEffect(() => {
        dispatch(setTotalFee(total)); // update total fee in redux
    }, [total])

    return (
        <div style={styles.container}>
            <Row label={'Subtotal'} value={subtotal} />
            <Row label={'Fees'} value={fees} />
            <Row label={'Total'} value={total} />
        </div>
    );
};

const styles = {
    row: {
        display:'flex', justifyContent:'space-between',
    },
    label: {
        fontSize: 18, fontWeight:400, color: 'darkgray', opacity:0.8,
        margin: 0, padding:0 
    },
    title: {
        fontSize: 18, fontWeight:400, color: 'black',
        margin: 0, padding:0 
    },
    container: {
        //borderStyle:'solid', borderWidth:1,
        padding: Spacing.SCALE_8
    }

}

export default CheckoutPricing;
